import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { CreateSupervisorAction } from '../../../libs/GraphQL';
import { PRETTY_TOAST_OPTS as TOAST_OPTS } from '../../../utils/toast';

// Fires `createSupervisorAction` mutations from the supervisor dashboard.
// Append-only audit log — BE has no update mutation, so re-completions
// just produce new records ordered by `createdAt` desc.
//
// Failures are non-blocking: a toast surfaces the issue but the caller's
// local commit (e.g. a section's Mark Complete flag) is never rolled back.
// Console.error captures the raw error for debugging.

const FAILURE_TOAST_MESSAGE =
  'Could not record supervisor action — your work is saved locally.';

export default function useSupervisorAction({
  fulfillmentCenter,
  market,
  reviewDate,
  reviewPhase,
}) {
  const submit = useCallback(
    async ({ eventType, data }) => {
      const input = {
        fulfillmentCenter,
        market,
        reviewDate,
        reviewPhase,
        eventType,
        data,
      };
      try {
        await CreateSupervisorAction(input);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('createSupervisorAction failed:', err);
        toast.error(FAILURE_TOAST_MESSAGE, TOAST_OPTS);
      }
    },
    [fulfillmentCenter, market, reviewDate, reviewPhase],
  );

  return { submit };
}
